<script setup lang="tsx">
import { inject } from "vue";
import { Context } from "@zyzgroup/core-web";
import { useRouter } from "../../hooks";
import Button from "../form/Button.vue";
import { dialog } from "../../globalTeleport";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Button },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    billsn: number;
  }>(),
  {
    billsn: 0
  }
);

const context = inject<Context>("context");

const router = useRouter();

function gotoPay() {
  // https://yaoyao.cebbank.com/LifePayment/webApp/h5/router.html?transType=01&canalType=13&canal=njczfs&ItemCode=860729765&userNo=32010025101035852255
  // router.push("/park");
  context.axios
    .post(
      `/api/v6/bill/${props.billsn}/pay`,
      {
        type: "B",
        openid: "quickpassapp"
      },
      {
        retry: 4,
        cache: 30
      }
    )
    .then((result) => {
      // console.log(result);
      // console.log(JSON.stringify(result));
      dialog({
        title: "",
        content: "请求成功，自行查看结果",
        confirmText: "知道了"
      });
    })
    .catch((result) => {
      // console.log(result);
      // console.log(JSON.stringify(result));
      dialog({
        title: "接口出错",
        content: result.data.error,
        confirmText: "知道了"
      });
    });
}
</script>

<template>
  <div class="xg-footer">
    <div class="xg-footer-inner">
      <Button
        label="去支付"
        width="100%"
        @click="gotoPay"
      ></Button>
    </div>
  </div>
</template>

<style scoped>
.xg-footer {
  box-sizing: border-box;
  background-color: #ffffff;
  border-top: 1px solid #cccccc;
}
.xg-footer-inner {
  box-sizing: border-box;
  width: 100%;
  padding: 0.2rem 0.3rem;
}
</style>
